const infoIcons = {
  NoContent: 'no-content',
  NoPlaces: 'no-places',
  NoPower: 'no-power',
  NoGraph: 'no-graph',
  Wait: 'wait'
};

export { infoIcons };
